var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMediumFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14.277
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3825",
    d: "M2.134 2.914a.7.7 0 00-.227-.594L.227.302v-.3h5.217l4.035 8.847 3.545-8.853H18v.3l-1.436 1.377a.42.42 0 00-.16.4v10.126a.42.42 0 00.16.4l1.4 1.377v.3h-7.06v-.3l1.454-1.411c.149-.149.149-.184.149-.4V3.99L8.462 14.256h-.547L3.209 3.99v6.881a.953.953 0 00.261.79l1.891 2.293v.3H0v-.3l1.891-2.293a.918.918 0 00.244-.79z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "static/media/medium_full.b9cf8692d4e66f0e5943d362d5f28b04.svg";
export { SvgMediumFull as ReactComponent };